import React, { Component, Fragment } from 'react';
import { DetailsList, SelectionMode, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { MessageBars } from '../Outils/MessageBars';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { FicheContact } from '../Fiche/FicheContact/FicheContact';
import { FicheDenonciation } from '../Fiche/FicheDenonciation';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { DataDenonciation } from '../../data/DataDenonciation';
import PerimetreContext from '../../contexts/PerimetreContext';

/*
***************************************************************
 PROPS:
    appelDepuisContact
    idContact
***************************************************************
*/

export class DetailsListDenonciation extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListDenonciationWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListDenonciationWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _selection;

    _creationContent() {
        const { items } = this.state;

        return (
            <DetailsList
                setKey="items"
                items={items}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                selectionMode={SelectionMode.single}
                columns={this.columns}
                selection={this._selection}
                selectionPreservedOnEmptyClick={false}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onRenderItemColumn={this._onRenderItemColumn}
            />
        );
    }

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => this.setState({ selectionDetails: this._getSelectionDetails() })
        });

        this.state = {
            items: [],

            //permet de stocker les infos de la ligne sur laquelle on a cliqué
            idContact: 0,
            idOperation: 0,
            loginCompte: '',
            date: '',

            enCoursDeTraitement: false,
            onAffichePanelDenonciation: false,
            onAffichePanelFiltre: false,
            onAffichePanelContact: false,
            appelFicheContactEnModeCreation: false,
            onAfficheDialogSuppressionDenonciation: false,

            peutDenoncerDesContacts: false,

            pageIndex: 1,
            facteurNbreEnregistrement: 500,
            tri: "",
            denonciationActive: true,

            hideMessageBarWarning: true,
            hideMessageBarError: true,
            hideMessageBarFiltres: true,
            warningMessage: '',
            errorMessage: '',
            messageMessageBarFiltres: '',

            filtreActive: true,

            recherche: '',

            selectionDetails: this._getSelectionDetails(),

            nombreMinSlider: 100,
            nombreMaxSlider: 10000,
            stepSlider: 500,
        };

        //#region chargement des columns
        let columnsTemp = [];

        columnsTemp.push({
            key: 'active',
            name: 'Active',
            fieldName: 'Active',
            minWidth: 50,
            maxWidth: 50,
            isResizable: true,
            isSorted: false,
            onRender: (item) => {
                if (item.active) {
                    return <IconButton
                        iconProps={{ iconName: 'Accept' }}
                    />;
                }
                else {
                    return <IconButton
                        iconProps={{ iconName: 'Blocked' }}
                    />;
                }
            }
        });

        columnsTemp.push({
            key: 'NomContact',
            name: 'Contact',
            fieldName: 'NomContact',
            minWidth: 150,
            maxWidth: 400,
            isResizable: true,
            onRender: (item) => {
                let nomContact = item.nomContact;
                return <span title={nomContact}>{nomContact}</span>;
            }
        });
        columnsTemp.push({
            key: 'Date',
            name: 'Date de création',
            fieldName: 'Date',
            minWidth: 150,
            maxWidth: 250,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let date = Scriba.date().stringDateHeureFormatCourt(item.date);
                return <span title={date}>{date}</span>;
            }
        });
        columnsTemp.push({
            key: 'NomCommercialOperationDenonciation',
            name: 'Opération',
            fieldName: 'NomCommercialOperationDenonciation',
            minWidth: 150,
            maxWidth: 400,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',

            onRender: (item) => {
                let nomCommercialOperationDenonciation = item.nomCommercialOperationDenonciation;
                return <span title={nomCommercialOperationDenonciation}>{nomCommercialOperationDenonciation}</span>;
            }
        });
        columnsTemp.push({
            key: 'nomVendeurPlusSociete',
            name: 'Dénoncé par',
            fieldName: 'nomVendeurPlusSociete',
            minWidth: 150,
            maxWidth: 400,
            isResizable: true,
            onRender: (item) => {
                let nomVendeurPlusSociete = item.nomVendeurPlusSociete;
                return <span title={nomVendeurPlusSociete}>{nomVendeurPlusSociete}</span>;
            }
        });
        columnsTemp.push({
            key: 'DateEcheance',
            name: 'Echéance',
            fieldName: 'DateEcheance',
            minWidth: 150,
            maxWidth: 250,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',

            onRender: (item) => {
                let dateEcheance = Scriba.date().stringDateHeureFormatCourt(item.dateEcheance);
                return <span title={dateEcheance}>{dateEcheance}</span>;
            }
        });

        if (!this.props.appelDepuisContact) {
            columnsTemp.push({
                key: 'EditionContact',
                name: '',
                ariaLabel: 'Modifier le contact',
                fieldName: 'EditionContact',
                minWidth: 40,
                maxWidth: 40,
                isIconOnly: true,
                isSorted: false,
                onRender: (item) => {
                    if (item.peutEditerContact) {
                        return <IconButton
                            iconProps={{ iconName: 'EditContact' }}
                            title="Modifier le contact"
                            ariaLabel="Edition"
                            onClick={() => this._onAffichagePanelContact(item.idContact)}
                        />;
                    }
                    else {
                        return null;
                    }
                }
            });
        }

        columnsTemp.push({
            key: 'delete',
            name: 'Delete',
            ariaLabel: 'Supprimer la dénonciation',
            fieldName: 'delete',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                if (item.peutSupprimer) {
                    return <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        title="Supprimer la dénonciation"
                        ariaLabel="Suppression"
                        onClick={() => this._onAffichageDialogSuppressionDenonciation(item.idContact, item.idOperation, item.date, item.loginCompte)}
                    />;
                }
                else {
                    return null;
                }
            }
        });

        this.columns = columnsTemp;
        //#endregion
    }
    _getItems = () => {
        let tableauBoutons = [{
            key: 'search',
            onRender: () => <SearchBox
                placeholder="Recherche rapide"
                className="searchBox"
                onSearch={value => this._onSearchBox(value)}
                onClear={(e) => this._onSearchBox('')}
            //onBlur={(e) => this._onBlurSearchBox(e.target.value)}
            />
        }];

        if (this.state.peutDenoncerDesContacts) {
            if (this._selection.getSelectedCount() > 0 | (this.props.idContact > 0)) {

                let idContact = 0;
                if (this.props.idContact > 0) {
                    idContact = this.props.idContact;
                }
                else {
                    this._selection.getSelection().map(function (denonciation) {
                        idContact = denonciation.idContact;
                    });
                }

                let boutonNouvelleDenonciation = {
                    key: 'nouvelleDenonciation',
                    name: 'Nouvelle dénonciation',
                    iconProps: {
                        iconName: 'Add'
                    },
                    onClick: (() => this._onAffichagePanelDenonciation(idContact))
                }

                tableauBoutons.push(boutonNouvelleDenonciation);
            }
        }

        // On affiche le bouton dans la fiche contact
        //if (this.props.idContact > 0) {
        //}

        return tableauBoutons;
    }
    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                //disabled: this.state.disableFiltres,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
    }

    _onSuppressionDenonciation = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression de la dénonciation en cours'
        });

        //var objet = {
        //    "idContact": this.state.idContact,
        //    "idOperation": this.state.idOperation,
        //    "date": this.state.date,
        //    "loginCompte": this.state.loginCompte
        //}

        //AF -  Ces données ne sont utilisées que pour la suppression
        //-------------------------------------
        let denonciation = {};
        denonciation.loginCompte = this.state.loginCompte
        denonciation.date = this.state.date;

        let listeIdOperations = [];
        listeIdOperations.push(this.state.idOperation);
        denonciation.listeIdOperations = listeIdOperations;

        let listeIdContacts = [];
        listeIdContacts.push(this.state.idContact);

        let onSuppressionDenonciation = DataDenonciation._onSuppressionDenonciation(listeIdContacts, denonciation);
        onSuppressionDenonciation
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {                    
                    // MG - 23/02/2022 - retirer le denonciation supprimé du state pour recharger
                    this.setState(prevState =>
                    ({
                        items: prevState.items.filter(item => item.idContact !== listeIdContacts[0] &&
                            item.loginCompte !== this.state.loginCompte &&
                            denonciation.listeIdOperations.map(de => de.idOperation !== this.state.idOperation)),

                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarError: true,
                        errorMessage: '',

                        onAfficheDialogSuppressionDenonciation: false,

                        idContact: 0,
                        idOperation: 0,
                        loginCompte: '',
                        date: ''
                    }), this._chargementDonnees);
                }
                else {
                    let stateTemp = {};
                    stateTemp.onAfficheDialogSuppressionDenonciation = false;
                    stateTemp.idContact = 0;
                    stateTemp.idOperation = 0;
                    stateTemp.loginCompte = '';
                    stateTemp.date = '';

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });

    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des dénonciations en cours'
        });

        let chargementDenonciation = DataDenonciation._chargementDenonciation(this.props.idContact, this.state.facteurNbreEnregistrement, this.state.recherche, this.state.tri, this.state.pageIndex, this.state.filtreActive);

        chargementDenonciation
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    let new_Items = [];
                    let retourData = responseFetch.reponseAPIobjet;
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (retourData[0] !== null ? retourData[0] : []);
                    let peutDenoncerDesContacts = retourData[1];

                    if (this.state.pageIndex === 1) {
                        new_Items = listeItem;
                    }
                    else {
                        new_Items = this.state.items;
                        new_Items = new_Items.concat(listeItem);
                    }

                    this.setState({
                        items: new_Items,
                        peutDenoncerDesContacts: peutDenoncerDesContacts,

                        enCoursDeTraitement: false,
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage,
                        hideMessageBarFiltres: (responseFetch.messageInfo === "" || responseFetch.messageInfo === null),
                        messageMessageBarFiltres: responseFetch.messageInfo
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.onAfficheDialogSuppressionDenonciation = false;
                    stateTemp.peutDenoncerDesContacts = false;
                    stateTemp.items = [];

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _getSelectionDetails() {
    }

    _onAffichagePanelContact = (idContact) => {
        this.setState({
            onAffichePanelContact: true,
            idContact: idContact,
            onAffichePanelFiltre: false
        });
    }

    _onAffichagePanelDenonciation = (idContact) => {
        this.setState({
            onAffichePanelDenonciation: true,
            idContact: idContact,
            onAffichePanelFiltre: false,
            onAffichePanelContact: false
        });
    }

    _onAffichePanelFiltre = () => {
        this.setState({
            onAffichePanelFiltre: true,
            onAffichePanelDenonciation: false,
            onAffichePanelContact: false
        });
    };

    _onAffichageDialogSuppressionDenonciation = (idContact, idOperation, date, loginCompte) => {
        this.setState({
            onAfficheDialogSuppressionDenonciation: true,

            idContact: idContact,
            idOperation: idOperation,
            date: date,
            loginCompte: loginCompte
        });
    }

    _onCachePanelContact = () => {
        this.setState({
            onAffichePanelContact: false,
            idContact: 0
        });
    };

    _onCachePanelDenonciation = () => {
        this.setState({
            onAffichePanelDenonciation: false,
            idContact: 0
        });
    };

    _onCachePanelFiltre = () => {
        this.setState({
            onAffichePanelFiltre: false
        });
    };

    _onCachePanelDenonciationEtRechargementDesDonnees = () => {
        if (this.state.onAffichePanelDenonciation) {
            this.setState({
                onAffichePanelDenonciation: false,
                idContact: 0
            });

            this._chargementDonnees();
        }
    }

    _onCacheDialogSuppressionDenonciation = () => {
        this.setState({
            onAfficheDialogSuppressionDenonciation: false,

            idContact: 0
        });
    }

    _onCachePanelContactEtRechargementDesDonnees = () => {
        if (this.state.onAffichePanelContact) {
            this.setState({
                onAffichePanelContact: false,
                idContact: 0
            });

            this._chargementDonnees();
        }
    };

    _onSearchBox = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState({
            filtreActive: false,

            pageIndex: 1,
            facteurNbreEnregistrement: 500
        });
    }

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    };

    _incrementeNbreEnregistrementEtChargementDonnees() {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    //_modificationNbreEnregistrementParPageETrepositionnementDuScrollEnHautDeLaPage(value) {
    //    this.setState({
    //        facteurNbreEnregistrement: value,
    //        pageIndex: 1
    //    });
    //}

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    };

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const content = this._creationContent();
        let idContact = (this.props.appelDepuisContact ? this.props.idContact : this.state.idContact);

        //AF - On passe systematiquement une liste de contacts pour la dénonciation
        //-------------------------------
        let listeIdContacts = [];
        listeIdContacts.push(idContact)
        //-------------------------------

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="scrollablePaneWrapper">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={() => this._reinitFiltre()}
                            />
                        </div>
                    </div>

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <Toggle
                                label="Actives"
                                onText="Oui"
                                offText="Toutes"
                                checked={this.state.filtreActive}
                                onChanged={(checked) => this.setState({ filtreActive: checked })}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            <FicheContact
                appelFicheContactEnModeCreation={this.state.appelFicheContactEnModeCreation}
                idContact={idContact}
                isOpen={this.state.onAffichePanelContact}
                onAnnuleFiche={() => this._onCachePanelContactEtRechargementDesDonnees()}
                onEnregistrementFiche={() => this._onCachePanelContactEtRechargementDesDonnees()} // Jamais appelée ? Inutile ?
                pasDAccesAHistorique={false}
                pasDAccesAuxDenonciations={false}
                pasDAccesAuxSouhaits={false}
                pasDAccesAuxSouhaitsMaisonIndividuelle={false}
            //onRechargeFiche={(idContactSelectionne) => this._onRechargeFicheContact(idContactSelectionne)}
            //onPeutChargerLeComposant={this.state.onAffichePanelContact}
            />

            <FicheDenonciation
                estAffectation
                isOpen={this.state.onAffichePanelDenonciation}
                listeIdContacts={listeIdContacts}
                onDismiss={() => this._onCachePanelDenonciation()}
                onSave={() => this._onCachePanelDenonciationEtRechargementDesDonnees()}
            />

            <Dialog
                hidden={!this.state.onAfficheDialogSuppressionDenonciation}
                onDismiss={this._onCacheDialogSuppressionDenonciation}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Suppression de la dénonciation',
                    subText: 'Attention, vous êtes en train de supprimer une dénonciation, souhaitez-vous continuer?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._onSuppressionDenonciation()} text="Supprimer" />
                    <DefaultButton onClick={this._onCacheDialogSuppressionDenonciation} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>;
    }
}